export default __webpack_public_path__ + "static/media/canva2.445cda96.gif";